import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/grainSpecifications',
    meta: { title: '粮油规格' },
    component: Layout,
    redirect: '/grainSpecifications/list',

    children: [
      {
        path: 'list',
        meta: { title: '粮油规格' },
        component: () => import('@/views/grainSpecifications/GrainSpecifications')
      },
      {
        path: 'add',
        meta: {
          title: '粮油规格新增',
          activeMenu: '/grainSpecifications'
        },
        component: () => import('@/views/grainSpecifications/GrainSpecificationsAdd')

      },
      {
        path: 'edit',
        meta: {
          title: '粮油规格编辑',
          activeMenu: '/grainSpecifications'
        },
        component: () => import('@/views/grainSpecifications/GrainSpecificationsAdd')

      },
      {
        path: 'detail',
        meta: {
          title: '粮油规格详情',
          activeMenu: '/grainSpecifications'
        },
        component: () => import('@/views/grainSpecifications/GrainSpecificationsDetail')

      }

    ]
  }
]
